// eslint-disable-next-line import/order
import type { ComponentType, ClassAttributes, HTMLAttributes } from 'react';

import { styled, type StyledProps } from '@compiled/react';

// eslint-disable-next-line import/order
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AIWhoAnswerSectionResultsWrapper: ComponentType<
	ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
	// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled.div({
	display: 'grid',
	gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
	gap: token('space.100'),
	width: '100%',
	height: '56px',
	marginTop: token('space.100'),
});
